<div class="inner-card">
  <div class="d-flex flex-column flex-grow-1">
    <!-- Title on its own row when both active and scheduled (not annual cleared) -->
    <div *ngIf="activeInstruction && scheduledForm && !isAnnualCleared" class="payment-title mb-2" i18n>
      {{ cardTitle }}
    </div>

    <!-- Active row (hidden when annual cleared) -->
    <div *ngIf="activeInstruction && !isAnnualCleared" class="d-flex align-items-center justify-content-between">
      <div class="d-flex flex-column gap-1">
        <div *ngIf="!scheduledForm" class="payment-title" i18n>{{ cardTitle }}</div>
        <div *ngIf="scheduledForm && isMonthly" class="payment-start" i18n>
          {{
            scheduledForm.controls.paymentStartMonth.value
              | vbPaymentChangeFrequencyDateString
                : VbPaymentChangeDateDisplayMode.ActiveWithScheduled
                : scheduledForm.controls.paymentStartYear.value ?? -1
          }}
        </div>
        <div *ngIf="scheduledForm && !isMonthly" class="payment-start" i18n>
          {{
            activeInstruction?.paymentStartDate
              | vbPaymentChangeFrequencyDateString
                : VbPaymentChangeDateDisplayMode.ActiveAnnualWithScheduled
                : scheduledForm.controls.paymentStartYear.value ?? -1
          }}
        </div>
        <div *ngIf="!scheduledForm && !isMonthly" class="payment-start" i18n>
          {{
            activeInstruction.paymentStartDate
              | vbPaymentChangeFrequencyDateString : VbPaymentChangeDateDisplayMode.ActiveOnlyAnnual
          }}
        </div>
      </div>
      <ng-container
        *ngTemplateOutlet="
          amountBlock;
          context: {
            amount: activeInstruction.paymentAmount,
            amountType: getActiveAmountType(activeInstruction),
            noAmount: false,
            showEdit: scheduledForm ? 'hidden' : !readonly ? 'visible' : null
          }
        " />
    </div>

    <hr *ngIf="activeInstruction && scheduledForm && !isAnnualCleared" class="my-2" />

    <!-- Scheduled row (hidden when annual cleared) -->
    <div *ngIf="scheduledForm && !isAnnualCleared" class="d-flex align-items-center justify-content-between">
      <div class="d-flex flex-column gap-1">
        <div *ngIf="!activeInstruction" class="payment-title" i18n>{{ cardTitle }}</div>
        <div class="d-flex align-items-center gap-3">
          <div class="payment-start" i18n>
            {{
              scheduledForm.controls.paymentStartMonth.value
                | vbPaymentChangeFrequencyDateString
                  : VbPaymentChangeDateDisplayMode.Scheduled
                  : scheduledForm.controls.paymentStartYear.value ?? -1
            }}
          </div>
          <app-tertiary-button
            *ngIf="!scheduledLocked"
            [size]="BaseButtonSizeEnum.md"
            (buttonClicked)="removeClicked.emit()"
            i18n>
            Remove
          </app-tertiary-button>
        </div>
      </div>
      <ng-container
        *ngTemplateOutlet="
          amountBlock;
          context: {
            amount: scheduledForm.controls.paymentAmount.value ?? 0,
            amountType: isScheduledStop ? null : scheduledForm.controls.recurringPaymentAmountType.value,
            noAmount: isScheduledStop || scheduledForm.controls.paymentAmount.value === null,
            showEdit: !readonly ? scheduledEditVisibility : null
          }
        " />
    </div>

    <!-- Empty state (or annual cleared) -->
    <div
      *ngIf="(!activeInstruction && !scheduledForm) || isAnnualCleared"
      class="d-flex align-items-center justify-content-between">
      <div class="d-flex flex-column gap-1">
        <div class="payment-title" i18n>{{ cardTitle }}</div>
        <div class="payment-start" i18n>No payment details entered</div>
      </div>
      <ng-container
        *ngTemplateOutlet="
          amountBlock;
          context: {
            amount: 0,
            amountType: null,
            noAmount: true,
            showEdit: !readonly ? scheduledEditVisibility : null
          }
        " />
    </div>
  </div>
</div>

<ng-template
  #amountBlock
  let-amount="amount"
  let-amountType="amountType"
  let-noAmount="noAmount"
  let-showEdit="showEdit">
  <div class="d-flex gap-4 align-items-center">
    <div class="d-flex flex-column gap-1 align-items-end">
      <div class="payment-amount" [class.no-amount]="noAmount" i18n>{{ amount | currency }} / {{ unit }}</div>
      <div *ngIf="amountType" class="payment-type">
        {{ amountType | recurringPaymentAmountTypeName }}
      </div>
    </div>
    <app-tertiary-button
      *ngIf="showEdit"
      leftIconSrc="assets/icons/primary/EditIcon.svg"
      [size]="BaseButtonSizeEnum.md"
      [style.visibility]="showEdit === 'hidden' ? 'hidden' : 'visible'"
      (buttonClicked)="editClicked.emit()"
      i18n>
      Edit
    </app-tertiary-button>
  </div>
</ng-template>
